module.exports = __webpack_public_path__ + "CreativeDirection3.png?8b58e517cff65fedb8d3273c2ee42daf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CreativeDirection3.png
// module id = 42
// module chunks = 0